import { useEffect, useRef } from 'react';
import { useGetMyInfoQuery } from 'src/hooks/useGetMyInfoQuery';
import { homePath } from 'src/routes/constants';

import { useNavigate } from 'components/Nav';

import { useAcceptInviteMutation } from '../views/SignUpPage/queries/useAcceptInviteMutation';
import { useUserQuery } from '../views/SignUpPage/queries/useUserQuery';

interface UseAcceptInviteReturn {
  isAcceptingInvite: boolean;
  invitedEmail: string | undefined;
}

/**
 * Custom hook that handles invite acceptance logic
 * Manages the complete invite acceptance flow including navigation
 */
export const useAcceptInvite = (): UseAcceptInviteReturn => {
  const navigate = useNavigate();
  const inviteAcceptedRef = useRef(false);
  
  // Fetch data directly
  const { data: user } = useUserQuery();
  const { data: myInfo } = useGetMyInfoQuery();
  const { mutate: acceptInvite, isPending: isAcceptingInvite } = useAcceptInviteMutation();

  const orgId = myInfo?.orgRole?.org.id;
  const invitedEmail = user?.publicMetadata?.invitedEmail as string || undefined;

  // Handle invite acceptance flow with useEffect
  useEffect(() => {
    if (user && myInfo && !orgId && invitedEmail && !inviteAcceptedRef.current) {
      console.debug('User has invited email, accepting invite');
      inviteAcceptedRef.current = true;

      acceptInvite({ data: invitedEmail, toastId: 'accept-invitation' }, {
        onSuccess: () => {
          console.log(`Invite accepted for ${invitedEmail}, navigating to /home/projects`);
          navigate(homePath);
        },
      });
    }
  }, [user, myInfo, orgId, invitedEmail, acceptInvite, navigate]);

  return {
    isAcceptingInvite,
    invitedEmail,
  };
};

